import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { routerMiddleware } from 'react-router-redux'
import blockMiddleware from 'react-block-ui/reduxMiddleware'

import { rootReducer } from 'Reducers/index'
import { rootSaga } from 'Reducers/sagas'
import { history } from './history'
import { errorMessageMiddleware } from 'Config/middlewares'

import { getCampaignMetricsMiddleware } from 'Reducers/Metric/middleware'
import {
  getCampaignResultsMiddleware,
  createCampaignMiddleware,
  updateCampaignMiddleware,
  getCampaignByIdMiddleware,
  getActiveCampaignsMiddleware,
} from 'Reducers/Campaigns/middleware'

import {
  moveInventoryMiddleware,
  loadInventoryMiddleware,
  addInventoryItemMiddleware,
  addFlyerCodesMiddleware,
  getInventoryItemMiddleware,
  deleteFlyerCodeMiddleware,
} from 'Reducers/Inventory/middleware'
import {
  createMissionsMiddleware,
  deleteMissionsMiddleware,
  publishMissionsMiddleware,
  unbookMissionsMiddleware,
  getMissionByIdMiddleware,
  updateMissionMiddleware,
} from './../Reducers/Mission/middleware'
import {
  getBrandAmbassadorProfileMiddleware,
  getBrandAmbassadorProfilesListMiddleware,
} from './../Reducers/Ambassador/middleware'
import { updateCityMiddleware } from './../Reducers/City/middleware'
import { deleteUserMiddleware } from '../Reducers/Users/middleware'
import {
  getLegalDocumentsMiddleware,
  getLegalDocumentByIdMiddleware,
  createLegalDocumentMiddleware,
  updateLegalDocumentByIdMiddleware,
  deleteLegalDocumentByIdMiddleware,
} from '../Reducers/LegalDocument/middleware'

const sagaMiddleware = createSagaMiddleware()
const routerHistoryMiddleware = routerMiddleware(history)
/**
 * @param {{__REDUX_DEVTOOLS_EXTENSION_COMPOSE__:function}} window
 */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(
      moveInventoryMiddleware,
      getCampaignMetricsMiddleware,
      loadInventoryMiddleware,
      addInventoryItemMiddleware,
      addFlyerCodesMiddleware,
      deleteFlyerCodeMiddleware,
      getInventoryItemMiddleware,
      getCampaignResultsMiddleware,
      createCampaignMiddleware,
      updateCampaignMiddleware,
      getCampaignByIdMiddleware,
      getActiveCampaignsMiddleware,
      createMissionsMiddleware,
      deleteMissionsMiddleware,
      publishMissionsMiddleware,
      unbookMissionsMiddleware,
      getMissionByIdMiddleware,
      updateMissionMiddleware,
      updateCityMiddleware,
      deleteUserMiddleware,
      getBrandAmbassadorProfileMiddleware,
      getBrandAmbassadorProfilesListMiddleware,
      getLegalDocumentsMiddleware,
      getLegalDocumentByIdMiddleware,
      createLegalDocumentMiddleware,
      updateLegalDocumentByIdMiddleware,
      deleteLegalDocumentByIdMiddleware,
      // Middleware above must come above, because middleware below
      // messes up the return value
      blockMiddleware,
      sagaMiddleware,
      routerHistoryMiddleware,
      errorMessageMiddleware,
    ),
  ),
)
sagaMiddleware.run(rootSaga)

export default store
